const useGridLayoutTracking = ({
  totalNumResults,
  cioFilterName,
  cioFilterValue,
}) => {
  const trackingTags = {
    'data-cnstrc-browse': '',
    'data-cnstrc-num-results': totalNumResults,
    'data-cnstrc-filter-name': cioFilterName,
    'data-cnstrc-filter-value': cioFilterValue,
    'data-autotag': 'prodgrid',
    'data-grid-version': 'CIO v1.1',
  };

  return {
    trackingTags,
  };
};

export default useGridLayoutTracking;
